module.exports = __webpack_public_path__ + "static/step-2-7f2670c68c3d0ec6986e3c32f4a077e4.png";